import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex } from 'pcln-design-system'
import Tile from '../../atoms/Tile'

const TileOption = styled(Tile)`
  width: calc(50% - ${(props) => props.theme.space[1]}px);
  margin-bottom: ${(props) => props.theme.space[2]}px;
  ${(props) =>
    props.index % 2 ? `margin-left: ${props.theme.space[1]}px;` : `margin-right: ${props.theme.space[1]}px;`}
`

const TileCategoryGroup = ({ className, handleChange, filters: tiles }) => {
  if (!tiles?.length) return null

  const onChange = (event) => {
    handleChange(
      {
        [event.target.value]: event.target.checked,
      },
      event
    )
  }

  return (
    <Flex className={className} flexWrap='wrap' mt={3} onChange={onChange}>
      {tiles.map((tile, index) => (
        <TileOption key={`tile-${tile?.label}`} index={index} {...tile} />
      ))}
    </Flex>
  )
}

TileCategoryGroup.propTypes = {
  className: PropTypes.string,
  handleChange: PropTypes.func,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      checked: PropTypes.bool,
      dataAutobotElementId: PropTypes.string,
      description: PropTypes.string,
      disabled: PropTypes.bool,
      icon: PropTypes.node,
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    })
  ),
}

export default TileCategoryGroup
